window.VjsUtility = (function(my){
    var self = my.Request = function(){};

    /**
     * @desc parsing function for the success response request
     * @type function
     */
    var successParser = null;

    /**
     * @desc function to set the success parser for the request calls
     * @param sParser {function} success parser function
     */
    self.setParser = function(sParser){
        if (sParser){
            if (typeof sParser !== "function") throw new Error("VjsUtility -> Request -> setParser : invalid success parser type");
            successParser = sParser;
        }
    }

    /**
     * @desc GET request
     * @param url {String} Required
     * @param params {Object}
     */
    self.prototype.get = function(url, params) {
        var $d = $.Deferred();
        $.get(url, params)
            .done(function(res) {
                if(successParser){
                    res = successParser(res);
                }
                $d.resolve(res);
            })
            .fail(function(x, h, r) {
                $d.reject(x, h, r);
            });
        return $d;
    };

    /**
     * @desc POST request
     * @param url {String} Required
     * @param params {Object}
     */
    self.prototype.post = function(url, params) {
        var $d = $.Deferred();
        $.post(url, params)
            .done(function(res) {
                if(successParser){
                    res = successParser(res);
                }
                $d.resolve(res);
            })
            .fail(function(x, h, r) {
                $d.reject(x, h, r);
            });
        return $d;
    };

    /**
     * @desc PUT request
     * @param url {String} Required
     * @param params {Object}
     */
    self.prototype.put = function(url, params) {
        if (typeof params !== "object") {
            params = { _METHOD: "PUT" };
        } else {
            params["_METHOD"] = "PUT";
        }
        var $d = $.Deferred();
        $.post(url, params)
            .done(function(res) {
                if(successParser){
                    res = successParser(res);
                }
                $d.resolve(res);
            })
            .fail(function(x, h, r) {
                $d.reject(x, h, r);
            });
        return $d;
    };

    /**
     * @desc DELETE request
     * @param url {String} Required
     * @param params {Object}
     */
    self.prototype.delete = function(url, params) {
        if (typeof params !== "object") {
            params = { _METHOD: "DELETE" };
        } else {
            params["_METHOD"] = "DELETE";
        }
        var $d = $.Deferred();
        $.post(url, params)
            .done(function(res) {
                if(successParser){
                    res = successParser(res);
                }
                $d.resolve(res);
            })
            .fail(function(x, h, r) {
                $d.reject(x, h, r);
            });
        return $d;
    };

    return my;
}(window.VjsUtility || {}));
